import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function CompareShare() {
  const { slug } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/compare/shared/${slug}`);
        nav(`/compare?ids=${data.ids.join(",")}`, { replace: true });
      } catch {
        toast.error("Shared link not found");
        nav("/browse", { replace: true });
      }
    })();
  }, [slug, nav]);
  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-[#555]">
      Loading shared comparison…
    </div>
  );
}
